<div class="help-overlay" [class.is-open]="open()" (click)="onBackdropClick()">
  <div class="help-dialog" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
    <div class="help-header">
      <h2>{{ title() }}</h2>
      <button
        type="button"
        class="help-close"
        [attr.aria-label]="translations().closeAriaLabel"
        (click)="onCloseClick()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" aria-hidden="true" focusable="false">
          <line x1="16" y1="16" x2="48" y2="48" stroke="currentColor" stroke-width="4" stroke-linecap="round" />
          <line x1="48" y1="16" x2="16" y2="48" stroke="currentColor" stroke-width="4" stroke-linecap="round" />
        </svg>
      </button>
    </div>
    <ng-template #shortcutGroup let-group>
      <div class="help-group">
        <h3 class="help-group-title">{{ group.title }}</h3>
        <div class="help-group-list">
          @for (shortcut of group.shortcuts; track trackByShortcut($index, shortcut)) {
          <div class="help-row">
            <span class="help-keys">
              @for (combo of shortcut.keys; track combo; let comboLast = $last) {
                <span class="help-key-combo">
                  @for (key of splitCombo(combo); track key; let keyLast = $last) {
                    <span class="help-key">{{ key }}</span>
                    @if (!keyLast) {
                    <span class="help-key-join">+</span>
                    }
                  }
                </span>
                @if (!comboLast) {
                <span class="help-key-separator">{{ translations().keySeparator }}</span>
                }
              }
            </span>
            <span class="help-label">{{ shortcut.label }}</span>
          </div>
          }
        </div>
      </div>
    </ng-template>

    <div class="help-content">
      <div class="help-desktop-columns">
        <div class="help-column">
          @for (group of desktopColumns().left; track trackByGroup($index, group)) {
          <ng-container
            [ngTemplateOutlet]="shortcutGroup"
            [ngTemplateOutletContext]="{ $implicit: group }"
          ></ng-container>
          }
        </div>
        <div class="help-column">
          @for (group of desktopColumns().right; track trackByGroup($index, group)) {
          <ng-container
            [ngTemplateOutlet]="shortcutGroup"
            [ngTemplateOutletContext]="{ $implicit: group }"
          ></ng-container>
          }
        </div>
      </div>
      <div class="help-mobile-groups">
        @for (group of groups(); track trackByGroup($index, group)) {
        <ng-container
          [ngTemplateOutlet]="shortcutGroup"
          [ngTemplateOutletContext]="{ $implicit: group }"
        ></ng-container>
        }
      </div>
    </div>
  </div>
</div>
